import { asString, normalizeStringArray } from "./parse-properties";
import { extractBlockQuote, splitH3Entries, stripBlockQuotes } from "./parse-sections";
import type { OperationalNote, OpsSeverity } from "./types";

function coerceSeverity(value: unknown): OpsSeverity {
  if (value === "warning" || value === "critical" || value === "info") return value;
  return "info";
}

function parseTopProps(body: string): Record<string, unknown> {
  const props: Record<string, unknown> = {};
  for (const raw of stripBlockQuotes(body).split("\n")) {
    const m = raw.match(/^\s*-\s+([a-zA-Z_][a-zA-Z0-9_-]*)\s*:\s*(.*)$/);
    if (!m) continue;
    const key = m[1];
    const rawValue = (m[2] ?? "").trim();
    if (key === undefined || rawValue.length === 0) continue;
    if (rawValue.startsWith("[") && rawValue.endsWith("]")) {
      const inner = rawValue.slice(1, -1).trim();
      props[key] =
        inner.length === 0
          ? []
          : inner
              .split(",")
              .map((s) => s.trim().replace(/^"|"$/g, "").replace(/^'|'$/g, ""))
              .filter((s) => s.length > 0);
      continue;
    }
    let scalar: unknown = rawValue;
    if (
      (rawValue.startsWith('"') && rawValue.endsWith('"')) ||
      (rawValue.startsWith("'") && rawValue.endsWith("'"))
    ) {
      scalar = rawValue.slice(1, -1);
    }
    props[key] = scalar;
  }
  return props;
}

export function parseOperationalNotes(sectionBody: string): OperationalNote[] {
  const entries = splitH3Entries(sectionBody);
  return entries.map((entry) => {
    const id = entry.title.trim();
    const top = parseTopProps(entry.body);
    return {
      id,
      label: asString(top.label) ?? id,
      type: asString(top.type) ?? "info",
      severity: coerceSeverity(top.severity),
      why: asString(top.why),
      applies_to: normalizeStringArray(top.applies_to),
      content: extractBlockQuote(entry.body),
    };
  });
}
